import {
	BanIcon,
	Button, ButtonAppearance, ButtonColor, ButtonSize, CloseIcon, Dialog, LockIcon,
	UserLock,
} from '@aleph/shared-components';
import { useTranslation } from 'react-i18next';
import { RenderConfirmActionDialogProps } from 'wb-reddit/app/routes/hooks/useConfirmAction';

function ConfirmLogoutDialog({ onClose, onConfirm }: RenderConfirmActionDialogProps) {
	const { t } = useTranslation();

	return (
		<Dialog
			isOpen
			onClose={onClose}
		>
			<Dialog.Header
				preset={{
					prefix: <UserLock width={24}
						height={24}
					/>,
					title:  t('sp: confirm logout dialog title', 'Log out?'),
					suffix: <Button
						leftNode={
							<CloseIcon />
						}
						appearance={ButtonAppearance.GHOST}
						color={ButtonColor.GRAY}
						onClick={onClose}
						size={ButtonSize.LARGE}
					/>,
				}}
			/>
			<Dialog.Content>
				<p className="text-gray-800 font-medium">{t('sp: confirm logout dialog body 1', 'Do you want to sign out of your user account?')}</p>
				<p className="text-gray-800 font-normal text-[13px] leading-4">{t('sp: confirm logout dialog body 2', 'You will need to log in again when you come back next time.')}</p>
			</Dialog.Content>
			<Dialog.Footer>
				<Button
					title={t('sp: confirm logout dialog cancel button', 'Cancel')}
					data-testid="overlay-discard"
					onClick={onClose}
					leftNode={<BanIcon />}
					appearance={ButtonAppearance.GHOST}
				/>
				<Button
					title={t('sp: confirm logout dialog log out button', 'Log out')}
					leftNode={<LockIcon />}
					onClick={onConfirm}
					color={ButtonColor.RED}
				/>
			</Dialog.Footer>
		</Dialog>
	);
}

export default ConfirmLogoutDialog;
